import { render, staticRenderFns } from "./CidadeModal.vue?vue&type=template&id=6b6bb1bf&scoped=true"
import script from "./CidadeModal.vue?vue&type=script&lang=js"
export * from "./CidadeModal.vue?vue&type=script&lang=js"
import style0 from "./CidadeModal.vue?vue&type=style&index=0&id=6b6bb1bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6bb1bf",
  null
  
)

export default component.exports